import { profilePersonalInfoPage } from 'platform/forms-system/src/js/patterns/prefill';
import {
  dateOfBirthSchema,
  ssnSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { fullNameSchema } from '../../definitions';
import content from '../../locales/en/content.json';
import { showSponsorPrefill } from '../helpers';

const PERSONAL_INFO_CONFIG = {
  name: { show: true, required: true },
  ssn: { show: true, required: true },
  dateOfBirth: { show: true, required: true },
  vaFileNumber: { show: false, required: false },
  sex: { show: false, required: false },
};

/**
 * Builds a read-only personal information page for a sponsor certifier using
 * prefilled data synced into `sponsorName`, `sponsorDob`, and `sponsorSsn`.
 *
 * @param {Object} options
 * @param {string} options.key - page key within the chapter
 * @param {string} options.path - page URL path
 * @returns {Object} form config page keyed by `key`
 */
export const sponsorPrefillPage = ({ key, path }) => {
  const { [key]: page } = profilePersonalInfoPage({
    key,
    path,
    title: content['sponsor--prefill-info-title'],
    personalInfoConfig: PERSONAL_INFO_CONFIG,
    dataAdapter: { ssnPath: 'sponsorSsn' },
    depends: showSponsorPrefill,
  });

  return {
    [key]: {
      ...page,
      // keeps synced sponsor fields active when the editable pages are hidden
      schema: {
        type: 'object',
        properties: {
          sponsorName: fullNameSchema,
          sponsorDob: dateOfBirthSchema,
          sponsorSsn: ssnSchema,
        },
      },
    },
  };
};
